import request from '@/utils/request';


export default {
    //获取状态
    getStatusList: (param) => {
        return request({
            url: `/inputChoice/queryAutoloadInputChoice`,
            method: "post",
            data: param,
        });
    },
    getdCategory3: (param) => {
        return request({
            url: `/rmc/protein/farm/authorizedCategory3`,
            method: 'get',
        });
    },
    getCategory3: (param) => {
        return request({
            url: `/rmc/protein/farm/authorizedCategory3?category=${param}`,
            method: 'get',
        });
    },
    // 获取药品清单
    getDrugList: (param) => {
        return request({
            url: `/rmc/protein/medicine/queryPage`,
            method: 'post',
            data: param
        });
    },
    // 保存药品清单
    saveDrugList: (param) => {
        return request({
            url: `/rmc/protein/medicine/save`,
            method: 'post',
            data: param
        });
    },
    // 提交药品清单
    submitDrugList: (param) => {
        return request({
            url: `/rmc/protein/medicine/submit`,
            method: 'post',
            data: param
        });
    },
    // 批准药品清单
    approverDrugList: (param) => {
        return request({
            url: `/rmc/protein/medicine/pass`,
            method: 'post',
            data: param
        });
    },
    // 退回药品清单
    backDrugList: (param) => {
        return request({
            url: `/rmc/protein/medicine/back`,
            method: 'post',
            data: param
        });
    },
    // 药品清单详情
    getDrugInfo: (param, id) => {
        return request({
            url: `/rmc/protein/medicine/queryDetail/${id}`,
            method: 'post',
            data: param
        });
    },

    // 根据有效成分获取信息
    queryNature: (param) => {
        return request({
            url: `/rmc/protein/medicine/queryNature`,
            method: 'post',
            data: param
        });
    },
    // 根据有效成分获取下拉框信息
    queryNatureForSelect: (param) => {
        return request({
            url: `/rmc/protein/medicine/queryNatureForSelect`,
            method: 'post',
            data: param
        });
    },
    // 确认无更新
    approveAndNoUpdate: (param) => {
        return request({
            url: `/rmc/protein/medicine/approveAndNoUpdate`,
            method: 'post',
            data: param
        });
    },
    // 获取当前用户的sponsor
    getSponsorByUser: (param) => {
        return request({
            url: `/rmc/protein/medicine/getSponsorByUser`,
            method: 'post',
            data: param
        });
    },
    // 删除
    deleteDrug: (param) => {
        return request({
            url: `/rmc/protein/medicine/deleteProteinMedicine`,
            method: 'post',
            data: param
        });
    },
    // 确认无更新
    approveAndNoUpdate: (param) => {
        return request({
            url: `/rmc/protein/medicine/approveAndNoUpdate`,
            method: 'post',
            data: param
        });
    },
    // 查看历史
    queryHistoryPage: (param) => {
        return request({
            url: `/rmc/protein/medicine/queryHistoryPage`,
            method: 'post',
            data: param
        });
    },
    // 更新日志
    queryPageForUpdateLog: (param) => {
        return request({
            url: `/rmc/protein/medicine/queryPageForUpdateLog`,
            method: 'post',
            data: param
        });
    },
    // 更新日志导出
    downloadUpdateLogList: (param) => {
        return request({
            url: `/rmc/protein/medicine/downloadUpdateLogList`,
            method: 'post',
            data: param,
            responseType: "blob",
            fullResponse: true,
        });
    },
    // 报表导出
    exportMedicine: (param) => {
        return request({
            url: `/rmc/protein/medicine/exportMedicine`,
            method: 'post',
            data: param,
            responseType: "blob",
            fullResponse: true,
        });
    },
    // 药品清单季度报表导出
    exportMedicineSnapshot: (param) => {
        return request({
            url: `/rmc/protein/medicine/exportMedicineSnapshot`,
            method: 'post',
            data: param,
            responseType: "blob",
            fullResponse: true,
        });
    },
    // 导入模板
    importExcelForProteinMedicineTemp: (param) => {
        return request({
            url: `/rmc/protein/medicine/importExcelForProteinMedicineTemp`,
            method: 'get',
            data: param,
            responseType: "blob",
            fullResponse: true,
        });
    },
    // 通用名
    getCommonNames: (name) => {
        return request({
            url: `/rmc/protein/medicine/getCommonNames`,
            method: 'post',
            data: name
        });
    },
    // 商品名
    getProductNames: (name) => {
        return request({
            url: `/rmc/protein/medicine/getProductNames`,
            method: 'post',
            data: name
        });
    },
    // 获取养殖模式
    getMedicineBreedingModeByAslGroup: (param) => {
        return request({
            url: "/rmc/protein/medicine/breedingModeList",
            method: 'get',
            params: param
        })
    }


}